import TicketComments from './Comments'
import TicketGet from './Get'
import TicketCreate from './Create'
export {
    TicketGet,
    TicketCreate,
    TicketComments,
}